import React from "react";

import Main from "../layouts/Main";

import { AboutJMTYIntro, AboutJMTY, OurMission, TheTeam } from "../components/AboutPage";
import PageBanner from "../components/PageBanner";

const About = () => (
  <Main>
    <PageBanner title="Our Story" />
    <TheTeam />
    <OurMission />
    <AboutJMTY />
  </Main>
);

export default About;
